import { html } from 'lit';
import componentStyles from './blockquote.css.lit.ts';
import { OutlineElement } from '../../base/outline-element/outline-element.ts';

export default class Blockquote extends OutlineElement {
  static styles = [super.styles, componentStyles];

  static get properties() {
    return {
      type: { type: String },
    };
  }

  constructor() {
    super();
    this.type = 'default'
  }

  render() {
    return html`<q class="blockquote ${this.type}"><slot></slot></q>`;
  }
}
customElements.define('hf-blockquote', Blockquote);
